import type { CollectionFieldPath, PrimitiveFieldPath } from '#layers/data-model/public';
import type { FilterSchemaLookup } from '#layers/filters/components/Filter/utils/filter-path';
import type { FilterSchemaCollection } from '#layers/filters/components/Filter/utils/filter-schema';
import { buildSegmentsFromFieldIds } from '#layers/filters/components/Filter/utils/filter-path';

/**
 * Whether a column's field path is filterable as a primitive terminal, reusing the same
 * collection-scoped path builder the filter bar uses. Eligible ≡ the path builds (every segment
 * resolves in the filter schema) and its terminal is a primitive — so the header action and the "+"
 * picker agree by construction, and virtual/unfilterable fields are excluded automatically.
 */
export function isFilterablePrimitivePath(
	fieldPath: CollectionFieldPath,
	collection: FilterSchemaCollection,
	schemaLookup: Pick<FilterSchemaLookup, 'findOppositeCollectionByRelationFieldId'>,
): boolean {
	if (fieldPath.length === 0) return false;

	try {
		const segments = buildSegmentsFromFieldIds(fieldPath as unknown as PrimitiveFieldPath, collection, schemaLookup);
		return segments.at(-1)?.type === 'primitive';
	}
	catch {
		return false;
	}
}
